import {IOrganization} from "./IOrganization";

export const initialOrganizationObj: IOrganization = {
    _id:"",
    name:"",
    metadata:{
        publisherLogin:{},
        adOpsContacts: []
    }
}